// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";

function toCss(param) {
  if (param.position) {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
                CssJs.position("absolute"),
                CssJs.bottom("zero"),
                CssJs.right("zero")
              ]);
  }
}

export {
  toCss ,
}
/* CssJs Not a pure module */
